import React from 'react';

import { useAppSelector } from 'redux/hooks';
import OrderFormWrapper from "components/Order/Form/OrderFormWrapper";
import {withParamsFrame} from "../HOCs";
import {IframePage} from "../types/iframe";
import OrdersSettingsFormWrapper from "../components/Order/Form/OrdersSettingsFormWrapper";

const Orders: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);

    const { sellerId } = useAppSelector(({ users, sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/${sellerId}/orders${httpParams}`}
                    title="Orders"
                    width="100%"
                    height={"calc(100vh-64px)"}
                ></iframe>

                <OrderFormWrapper/>
                <OrdersSettingsFormWrapper/>
            </div>
        </>
    );
};

export default withParamsFrame(Orders);
